@if (state() === 'otp') {
  <tc-otp
    [otpRequest]="otpRequest()"
    [otpDigitsFormArray]="form.controls.otpDigits"
    [isLoading]="isLoading()"
    [error]="error()"
    (submitted)="submit()"
    (resendOtp)="resetPasswordInit()"
  >
  </tc-otp>

} @else if (state() === 'password') {

  <div class="g-form-control">
    @let passwordControl = form.controls.password;

    <label
      class="g-form-label"
      for="password"
    >
      {{ 'global.new_password' | translate }}
    </label>
    <div class="g-form-control">
      <input
        class="g-form-input"
        [class.form-input-invalid]="isControlInvalid(passwordControl)"
        [formControl]="passwordControl"
        id="password"
        type="password"
        autocomplete="new-password"
      >

      @if (isControlInvalid(passwordControl)) {
        <div class="g-form-input-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="g-form-control">
    @let repeatPasswordControl = form.controls.repeatPassword;

    <label class="g-form-label" for="repeat-password">{{ 'global.repeat_new_password' | translate }}</label>
    <div class="g-form-control">
      <input
        class="g-form-input"
        [class.form-input-invalid]="isControlInvalid(repeatPasswordControl)"
        [formControl]="repeatPasswordControl"
        id="repeat-password"
        type="password"
        autocomplete="new-password"
      >

      @if (isControlInvalid(repeatPasswordControl)) {
        <div class="g-form-input-error">
          {{ 'global.passwords_dont_match' | translate }}
        </div>
      }
    </div>
  </div>

} @else if (state() === 'success') {

  <div class="success-header">
    {{ 'reset_password.success_header' | translate }}
  </div>

  <div class="success-text">
    {{ 'reset_password.success_text' | translate }}
  </div>
}

@if (state() !== 'otp') {
  @if (error()) {
    <div class="g-form-error">
      {{ error() }}
    </div>
  }

  <tc-button
    class="reset-password-submit"
    [isLoading]="isLoading()"
    (click)="submit()"
    buttonType="submit"
    buttonSize="large"
  >
    @if (state() === 'otp') {
      {{ 'global.next' | translate }}
    } @else if (state() === 'success') {
      {{ 'global.done' | translate }}
    } @else {
      {{ 'global.confirm' | translate }}
    }
  </tc-button>
}
